export default __webpack_public_path__ + "content/media/3.c12cf0c1.jpg";